import Vue from 'vue'

// Plugins etc.
import './plugins/bootstrap-vue'
import "vue-material-design-icons/styles.css"
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'

import App from './App.vue'

// Routes
import Dashboard from './routes/Dashboard.vue'
import Settings from './routes/Settings.vue'
import Kp27Day from './routes/Kp27Day.vue'
import ImageList from './routes/ImageList.vue'
import Archives from './routes/Archives.vue'
import Help from './routes/Help.vue'

const routes = [
  { path: '/', component: Dashboard },
  { path: '/settings', component: Settings },
  { path: '/kp27day', component: Kp27Day },
  { path: '/imagelist', component: ImageList },
  { path: '/archives', component: Archives },
  { path: '/help', component: Help }
]

Vue.use(VueRouter)
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_PROPERTY || ""
})

const router = new VueRouter({
  routes // short for `routes: routes`
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
